import { debounce } from "../utilities/limiters.js";

if ( document.querySelector( '.project-cards-slider' ) ) {
    jQuery( '.project-cards-slider' ).slick( {
        slidesToShow: 3,
        slidesToScroll: 1,
        swipeToSlide: true,
        arrows: true,
        fade: false,
        autoplay: false,
        rows: 0,
        infinite: false,
        prevArrow: '<svg class="slick-arrow slick-prev" xmlns="http://www.w3.org/2000/svg" width="24.571" height="36.413" viewBox="0 0 24.571 36.413"><path d="M21.388 33.231 6.363 18.206 21.388 3.181" fill="none" stroke="#e4034b" stroke-width="9"/></svg>',
        nextArrow: '<svg class="slick-arrow slick-next" xmlns="http://www.w3.org/2000/svg" width="24.571" height="36.413" viewBox="0 0 24.571 36.413"><path d="m3.182 3.182 15.025 15.025L3.182 33.232" fill="none" stroke="#e4034b" stroke-width="9"/></svg>',
        responsive: [
            {
                breakpoint: 991,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 1
                }
            },
            {
                breakpoint: 610,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    infinite: true
                }
            }
        ]
    } );

    // Aligns the case-study cards and their content with each other
    function equalizeCards() {
        const $cardInners = jQuery( ".project-card .card-inner" );
        const numberOfCardChildren = $cardInners[0].children.length;
        for ( let i = 0; i < numberOfCardChildren; i++ ) {
            $cardInners.each( ( j, card ) => {
                const component = card.children.item( i );
                jQuery( component ).css( "min-height", "unset" );
            } );
            requestAnimationFrame( () => {
                let maxHeight = 0;
                $cardInners.each( ( j, card ) => {
                    const component = card.children.item( i );
                    if ( !component ) return;
                    if ( jQuery( component ).height() > maxHeight ) { maxHeight = jQuery( component ).height(); }
                } );
                $cardInners.each( ( j, card ) => {
                    const component = card.children.item( i );
                    jQuery( component ).css( "min-height", maxHeight );
                } );
            } );
        }
    }

    jQuery( window ).on( 'resize', debounce( equalizeCards, 300 ) );
    jQuery( () => {
        equalizeCards();
    } );
}